import axiosApi from '@/utils/request'

// 写入操作日志
export function addNonUsersLog(headers = {}, params = {}) {
    return axiosApi('/index/add-non-users-log','post',params,headers,'',2)
}
